module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "epub:type": "prologue",
      "id": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("13 JULY 1961")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-r"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("R")]), _vm._v("ebecca is unsure whether to tell her father about the boy on the bus who just asked her out. She’s so excited, she’ll surely have to tell someone. But she doesn’t want to jinx it, or for her father to puncture the moment. Not that he’d do that deliberately. He might tell her not to count her chickens or say these things have a habit of not working out. On the other hand, she so loves chatting to him these days.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The house is silent when she unlocks the door. Rebecca knows her mother will be working at the furniture store and Eileen and Roland still at school. She goes straight into the front room where her father often sits reading. It is empty. She calls out to him. She definitely needs to tell him about the advert for the government trainee hairdressing scheme. He cuts all three of their hair so neatly, this is surely the course for him. Though to be fair, Roland’s complaints of looking like a pudding basin are usually justified. Her father could be out shopping, though he hates shopping. Or maybe he’s visiting his father.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She looks into the dining room, then shouts up the stairs. There is no answer. He’s not having a nap in bed and there’s no one in the bathroom. He is a habitual mender of broken objects, and it occurs to Rebecca that he must be in the garage engaged in some tedious task. She goes back downstairs and through to the tiny back garden and, sure enough, the garage door is unlocked. There’s a bulb switched on somewhere, but it is still murky inside. He must be on the stepladder, as he’s pretty high up when he turns towards her to say hello. A shaft of light from the door catches his face and she begins to tell him what a great day she’s had, but he keeps turning until she sees the back of his head which is balding, and, very slowly, he comes round a second time and, as her eyes adjust to the light, only now does she see the rope, thick, sturdy – probably brand new.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443afbb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 75
// module chunks = 0